import { useDetectAdBlock } from 'adblock-detect-react'
import { useEffect, useState } from 'react'

/**
 * Hook to detect if an ad-blocker is active
 * @returns Object containing isAdBlockerActive
 */

// TODO: This is hook sometimes returns false positives.

// We should find a better way to detect if an ad-blocker is active.
// We should also find a way to detect if an ad-blocker is active without using a library if library is not working as expected.

// Research:
// - https://stackoverflow.com/questions/76449668/how-to-properly-detect-ad-blocker-display-warning

export const useAdBlockerDetection = () => {
  const [isAdBlockerActive, setIsAdBlockerActive] = useState(false)
  const adBlockDetected = useDetectAdBlock()

  useEffect(() => {
    if (adBlockDetected) {
      setIsAdBlockerActive(true)
    }
  }, [adBlockDetected])

  return { isAdBlockerActive }
}
